var { populatePanelWithSvg, clearPanel } = require('./svgPanelUtils');
var { evaluateFormula } = require('../../../../libs/formulaSandbox');

function renderStaticSvg(node, options) {
  if (!node) return;

  const panel = node.findObject("body") || node.findObject("StaticSvgPanel");
  if (!panel) return;
  
  const staticSvgs = Array.isArray(options?.staticSvgs) ? options.staticSvgs : [];
  const formula = typeof options?.formula === 'string' ? options.formula : '';
  const pointValues = Array.isArray(options?.pointValues) ? options.pointValues : [];

  if (staticSvgs.length === 0) {
    clearPanel(panel);
    panel.__staticSvgCacheKey = null;
    panel.__staticSvgContent = null;
    if (typeof console !== 'undefined' && console && typeof console.warn === 'function') {
      console.warn(`[StaticSvg] No SVGs configured for ${options?.equipmentName || 'equipment'} (${options?.rid || 'unknown'})`);
    }
    return;
  }

  let indexResult = 1;
  if (formula && formula.trim()) {
    indexResult = evaluateStaticSvgFormula(formula, pointValues);
  }

  if (!Number.isFinite(indexResult)) indexResult = 1;
  let selectedIndex = Math.floor(indexResult);
  if (Number.isNaN(selectedIndex) || selectedIndex < 1) selectedIndex = 1;
  if (selectedIndex > staticSvgs.length) selectedIndex = staticSvgs.length;

  const selected = staticSvgs[selectedIndex - 1] || staticSvgs[0];
  const convertedCandidate = selected && typeof selected.svgConverted === 'string' ? selected.svgConverted : '';
  const trimmedSvg = (convertedCandidate || '').trim();
  if (!trimmedSvg) {
    console.warn('[StaticSvg] Missing svgConverted for static SVG selection.', {
      rid: options?.rid,
      equipmentName: options?.equipmentName,
      key: selected && selected.key
    });
    clearPanel(panel);
    panel.__staticSvgCacheKey = null;
    panel.__staticSvgContent = null;
    return;
  }
  if (!trimmedSvg) {
    clearPanel(panel);
    panel.__staticSvgCacheKey = null;
    panel.__staticSvgContent = null;
    return;
  }

  const cacheKey = `${selected.key}:${trimmedSvg}`;
  if (panel.__staticSvgCacheKey === cacheKey && panel.__staticSvgContent) {
    return;
  }

  populatePanelWithSvg(panel, trimmedSvg);
  panel.__staticSvgCacheKey = cacheKey;
  panel.__staticSvgContent = true;
}

function evaluateStaticSvgFormula(formula, pointValues) {
  try {
    const fn = new Function(`return (${formula})`)();
    if (typeof fn !== 'function') {
      return 1;
    }

    const args = (pointValues || []).map(value => {
      const numeric = Number(value);
      return Number.isFinite(numeric) ? numeric : 0;
    }).join(",");

    const result = evaluateFormula(formula, args);
    return Number(result);
  } catch (err) {
    if (typeof console !== 'undefined' && console && typeof console.warn === 'function') {
      console.warn(`[StaticSvg] Formula evaluation failed: ${err.message}`);
    }
    return 1;
  }
}

module.exports = {
  renderStaticSvg
};
